<template>
  <base-modal :title="title" :width="width" :visible="visible" @cancel="cancel">
    <div slot="modalBody">
      <a-form :form="form" @submit="handleSubmit">
        <a-row>
          <a-col :span="22">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="跟进时间">
              <a-input autocomplete="off" v-decorator="['traceTime']" />
            </a-form-item>
          </a-col>
          <a-col :span="22">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="进展情况">
              <a-textarea v-decorator="['info']" />
            </a-form-item>
          </a-col>
          <a-col :span="22">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="需要协调信息">
              <a-textarea v-decorator="['remark']" />
            </a-form-item>
          </a-col>
          <a-col :span="22">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="跟进状态">
              <a-input autocomplete="off" v-decorator="['statusName']" />
            </a-form-item>
          </a-col>
          <div v-if="isStatus === 'MARKET_STATUS_02'">
            <div v-if="isType === 1">
              <a-col :span="11">
                <a-form-item :labelCol="labelCol2" :wrapperCol="wrapperCol2" label="开标时间">
                  <a-input autocomplete="off" v-decorator="['openingTime']" />
                </a-form-item>
              </a-col>
              <a-col :span="11">
                <a-form-item :labelCol="labelCol2" :wrapperCol="wrapperCol2" label="中标金额">
                  <a-input autocomplete="off" addon-after="元" v-decorator="['winningPrice']" />
                </a-form-item>
              </a-col>
            </div>
            <div v-if="isType === 0">
              <a-col :span="11">
                <a-form-item :labelCol="labelCol2" :wrapperCol="wrapperCol2" label="中标时间">
                  <a-input autocomplete="off" v-decorator="['winningTime']" />
                </a-form-item>
              </a-col>
              <a-col :span="11">
                <a-form-item :labelCol="labelCol2" :wrapperCol="wrapperCol2" label="投标金额">
                  <a-input autocomplete="off" addon-after="元" v-decorator="['tenderPrice']" />
                </a-form-item>
              </a-col>
            </div>
          </div>
          <div v-if="isStatus === 'MARKET_STATUS_03'">
            <div v-if="isType === 1">
              <a-col :span="11">
                <a-form-item :labelCol="labelCol2" :wrapperCol="wrapperCol2" label="开标时间">
                  <a-input autocomplete="off" v-decorator="['openingTime']" />
                </a-form-item>
              </a-col>
            </div>
            <a-col :span="11">
              <a-form-item :labelCol="labelCol2" :wrapperCol="wrapperCol2" label="中标单位">
                <a-input autocomplete="off" v-decorator="['winningCompanyName']" />
              </a-form-item>
            </a-col>

            <a-col :span="11">
              <a-form-item :labelCol="labelCol2" :wrapperCol="wrapperCol2" label="中标金额">
                <a-input autocomplete="off" addon-after="元" v-decorator="['winningPrice']" />
              </a-form-item>
            </a-col>
            <div v-if="isType === 0">
              <a-col :span="11">
                <a-form-item :labelCol="labelCol2" :wrapperCol="wrapperCol2" label="投标金额">
                  <a-input autocomplete="off" addon-after="元" v-decorator="['tenderPrice']" />
                </a-form-item>
              </a-col>
            </div>
          </div>
          <a-col :span="22">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="业主联系人">
              <a-input autocomplete="off" v-decorator="['contactName']" />
            </a-form-item>
          </a-col>
          <a-col :span="22">
            <!-- <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="文件上传">
              <div v-for="item in fileList" :key="item.id" class="downloadFileList">
                <p>
                  {{ item.fileName }}
                  <a-icon type="download" v-if="item.id" @click="handleDownload(item)" />
                  <a-icon type="eye" v-if="item.id" @click="handlePreview(item)" />
                </p>
              </div>
            </a-form-item> -->

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="附件">
              <zm-preview
                :list="fileList"
                :previewUrl="$sysInfo.previewUrl"
                :baseUrl="$sysInfo.apiRemote"
                :account="$sysInfo.previewAccount"
                :token="$sysInfo.previewToken"
                :jwtToken="$store.state.user.token"
                downloadUrl="/market/file/"
              ></zm-preview>
            </a-form-item>
          </a-col>

          <!--          <a-col :span="24">-->
          <!--            <a-form-item-->
          <!--              :labelCol="labelCol"-->
          <!--              :wrapperCol="wrapperCol"-->
          <!--              label="市场跟进人"-->
          <!--              hasFeedback-->
          <!--            >-->
          <!--              <a-input-->
          <!--                placeholder="请输入跟进人"-->
          <!--                id="trackerId"-->
          <!--                class="itemWidth"-->
          <!--                :disabled="true" />-->
          <!--            </a-form-item>-->
          <!--          </a-col>-->
          <!--          <a-col :span="24">-->
          <!--            <a-form-item-->
          <!--              :labelCol="labelCol"-->
          <!--              :wrapperCol="wrapperCol"-->
          <!--              label="附件上传"-->
          <!--              hasFeedback-->
          <!--            >-->
          <!--              <a-upload-->
          <!--                name="file"-->
          <!--                :multiple="true"-->
          <!--                :action="uploadAction"-->
          <!--                :headers="headers"-->
          <!--                @change="handleChange"-->
          <!--              >-->
          <!--                <a-button>-->
          <!--                  <a-icon type="upload"/>-->
          <!--                  上传文件-->
          <!--                </a-button>-->
          <!--              </a-upload>-->
          <!--            </a-form-item>-->
          <!--          </a-col>-->
        </a-row>
      </a-form>
    </div>
  </base-modal>
</template>

<script>
// import Uploader from '@/CrComponents/Uploader'
import baseModal from '@/CrComponents/Modal/Modal.vue'
// import { downLoadFile } from '@/api/download'

export default {
  name: 'DetailsFollows',
  computed: {},
  components: {
    baseModal,
    // Uploader
  },
  data () {
    return {
      businessList: [],
      proprietorContactsList: [], // 业主联系人列表
      files: [],
      uploadAction: this.$sysInfo.apiRemote + '/upload/tmp/file',
      headers: {
        Authorization: this.$store.state.user.token
      },
      title: '操作',
      width: 1200,
      type: 'add', //  弹窗的类型： add:新增 |modify:修改 | del:删除
      infoLoading: false, // 编辑窗口，获取详情loading
      form: this.$form.createForm(this, { name: 'follows' }),
      visible: false,
      defaultModel: {},
      model: {},
      labelCol2: {
        xs: { span: 24 },
        sm: { span: 8 }
      },
      wrapperCol2: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      labelCol: {
        xs: { span: 24 },
        sm: { span: 4 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 20 }
      },
      contactList: [],
      fileList: [],
      isStatus: null,
      isType: ''
    }
  },
  methods: {
    // 设置类型
    setType (type) {
      this.type = type
    },
    // 设置标题
    setTitle (title) {
      this.title = title
    },
    // 设置model 参数 修改时传入
    setModel (model) {
      this.model = Object.assign({}, model)
    },
    // 打开or关闭，修改的窗口先获取详情
    open (flag) {
      this.visible = flag
      if (flag) {
        if (this.type !== this.$sysInfo.MODAL_ADD) {
          this.getModelInfo()
        }
      }
    },
    // 提交表单
    handleSubmit (e) {
      e.preventDefault()
    },
    // 获取当前的model详情
    getModelInfo () {
      this.$nextTick(() => {
        this.form.setFieldsValue({
          info: this.model.info,
          remark: this.model.remark,
          contactName: this.model.contactName,
          traceTime: this.model.traceTime,
          statusName: this.model.statusName
        })
        this.isStatus = this.model.status
        this.$nextTick(() => {
          if (this.isStatus === 'MARKET_STATUS_02') {
            if (this.model.openingTime) {
              this.isType = 1
            }
            if (this.model.winningTime) {
              this.isType = 0
            }
            this.$nextTick(() => {
              this.form.setFieldsValue({
                openingTime: this.model.openingTime,
                winningTime: this.model.winningTime,
                winningPrice: this.model.winningPrice,
                tenderPrice: this.model.tenderPrice
              })
            })
          }
          if (this.isStatus === 'MARKET_STATUS_03') {
            if (this.model.openingTime) {
              this.isType = 1
            }
            if (this.model.tenderPrice) {
              this.isType = 0
            }
            this.$nextTick(() => {
              this.form.setFieldsValue({
                openingTime: this.model.openingTime,
                winningCompanyName: this.model.winningCompanyName,
                winningPrice: this.model.winningPrice,
                tenderPrice: this.model.tenderPrice
              })
            })
          }
        })
      })
      this.fileList = [...this.model.files]
    },
    handleChange () {},
    // 清空表单
    formClear () {
      console.log('清空和数据')
      this.fileList = []
      this.model = {}
      this.isStatus = null
      this.$nextTick(() => {
        this.form.resetFields()
      })
      setTimeout(() => {
        // this.$refs.uploader.clearFileList()
      })
    },
    cancel () {
      this.formClear()
      this.open(false)
    },
    // handleUpload (fileList) {
    //   fileList.map((item) => {
    //     this.fileList.push(item)
    //   })

    //   this.$refs.uploader.clearFileList()
    // },
    // handleDownload (item) {
    //   console.log('item', item)
    //   var urlPath = '/opt/pms/back/dataSystem/marketFollow/' + item.filePath
    //   // return
    //   downLoadFile(urlPath).then((res) => {
    //     const blob = new Blob([res])
    //     const downloadElement = document.createElement('a') // 创建下载的链接
    //     const href = window.URL.createObjectURL(blob)
    //     downloadElement.href = href
    //     downloadElement.download = item.fileName // 下载后的文件名
    //     document.body.appendChild(downloadElement)
    //     downloadElement.click() // 下载
    //     document.body.removeChild(downloadElement) // 下载完成 移除 a
    //     window.URL.revokeObjectURL(href) // 释放blob对象
    //   })
    // },
    // handlePreview (item) {
    //   console.log('预览', item)
    //   var filePath = '/opt/pms/back/dataSystem/marketFollow/' + item.filePath
    //   window.open(
    //     `${this.$sysInfo.previewUrl}` +
    //       filePath +
    //       `&fileName=${item.filePath}` +
    //       `&account=${this.$store.state.user.info.account}` +
    //       `&token=${this.$store.state.user.info.token}` +
    //       '&jwtToken=' +
    //       this.$store.state.user.token
    //   )
    // }
  },
  mounted () {
    console.log('状态', this.type)

    // this.initContacts()
  }
}
</script>

<style scoped>
.itemWidth {
  width: 256px;
}
</style>
